import { useCallback, useState } from "react";
import { useSnackbar } from "notistack";
import { useIntl } from "react-intl";
import { getResponseMessage } from "../../../../utils";
import { getGPTModels } from "../../../../crud/users.crud";

type IModel = {
  created: number;
  id: string;
  object: string;
  owned_by: string;
};

export const useGPTModels = () => {
  const intl = useIntl();
  const { enqueueSnackbar } = useSnackbar();
  const [loadingModels, setLoading] = useState(false);
  const [models, setModels] = useState<IModel[]>([]);

  const fetchModels = useCallback(async () => {
    setLoading(true);
    getGPTModels()
      .then(res => {
        setModels(res.data.data.data);
      })
      .catch(e => {
        enqueueSnackbar(`${intl.formatMessage({ id: "NOTISTACK.ERRORS.ERROR" })} ${getResponseMessage(e)}`);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return {
    fetchModels,
    models,
    loadingModels,
  };
};
